<template>
    <section class="checkout-section">
        <header class="checkout-section__header">
            <h2 class="checkout-section__header__title">
                <slot name="header"></slot>
            </h2>
        </header>

<!--        <header class="heading-desc">-->
<!--            <div class="heading-desc&#45;&#45;heading">-->
<!--                <h2 class="heading-desc&#45;&#45;title">-->
<!--                    <slot name="header"></slot>-->
<!--                </h2>-->
<!--            </div>-->
<!--        </header>-->

        <div class="checkout-section__body">
            <slot></slot>

<!--            <footer class="checkout-section__footer">-->
<!--                <div class="checkout-section__footer__content">-->
<!--                    <div class="checkout-section__footer__amount">-->
<!--                        {{ $t('pages.checkout.subtotal') }} <slot name="footerAmount"></slot>-->
<!--                    </div>-->
<!--                </div>-->
<!--            </footer>-->
        </div>
    </section>
</template>

<script>
    export default {
        props: ['cssClass']
    }
</script>
